import { formatDate } from '@angular/common';
import { OfferListItem } from '../../../../../../pages/admin-dashboard/promotions/offers-management/offers.model';
import { OfferTableRow } from './offer-table-component.model';

function formatDiscount(offer: OfferListItem, isArabic: boolean): string {
  if (offer.discountType === 'VALUE') {
    return `${offer.discountValue} ${isArabic ? 'ج.م' : 'EGP'}`;
  }
  return `${offer.discountValue * 100}%`;
}

function toOfferTableRow(offer: OfferListItem, isArabic: boolean, locale: string): OfferTableRow {
  const start = formatDate(offer.startDate, 'mediumDate', locale);
  const end = formatDate(offer.endDate, 'mediumDate', locale);

  return {
    id: offer.id,
    title: (isArabic ? offer.titleAr : offer.titleEn) || offer.titleEn,
    offerType: (isArabic ? offer.offerType?.titleAr : offer.offerType?.titleEn) ?? '—',
    discount: formatDiscount(offer, isArabic),
    duration: isArabic ? `من ${start} إلى ${end}` : `${start} - ${end}`,
    status: { titleEn: offer.status?.titleEn ?? '—', titleAr: offer.status?.titleAr ?? '—' },
    activationStatus: offer.isActive
      ? { titleEn: 'Active', titleAr: 'نشط' }
      : { titleEn: 'Inactive', titleAr: 'غير نشط' },
  };
}

export function toOfferTableRows(offers: OfferListItem[], isArabic: boolean, locale: string): OfferTableRow[] {
  return offers.map((o) => toOfferTableRow(o, isArabic, locale));
}
